<template>
  <div style="width: 1200px; margin: 0 auto">
    <el-table @row-click="rowClick" style="margin-bottom: 20px" :show-header="false" :data="noticeList" :row-style="{height:'100px',cursor:'pointer'}">
      <el-table-column >
        <template slot-scope="scope">
          {{ scope.row.title }}
          <div>
            <el-tag>图片新闻</el-tag>
            {{ scope.row.createTime }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="4" :offset="9">
        <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
                    @pagination="getList"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {imageNews} from '../api/index'

export default {
  name: 'notice',

  data() {
    return {
      noticeList: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
    }
  },
  created() {
  this.getList()
  },
  methods: {
    rowClick(row, ){
       this.$router.push(`/showArt/${row.id}`)
    },
    getList(){
      imageNews(this.queryParams).then(res => {
            console.log(res)
        this.noticeList = res.data.rows
        this.total=res.data.total;
        //发布时间去掉时分秒
        for (const dataKey in res.data.rows) {
          this.noticeList[dataKey].createTime = res.data.rows[dataKey].createTime.split(' ')[0]
        }
      })
    },
  }
}
</script>

<style scoped>
::v-deep.el-table .cell {
  margin-left: 50px !important;
}
</style>
